import React, {FC} from 'react';
import {Alert, Button} from 'antd';
import {withTranslation, WithTranslation} from 'react-i18next';
import {NotificationItem} from 'src/stores/systemNotifications/notification-store';

interface Props extends WithTranslation {
    title: string;
    notification: NotificationItem;
    fileName: string;
    currentTime: string;
    downloadExcel: (data: any, fileName: string) => void;
}

const ExportNotification: FC<Props> = ({ title, notification, downloadExcel, fileName, currentTime, t }) => {
    return (
        <>
            {notification && !notification.data.MessageError && (
                <>
                    <div style={{ position: 'absolute', top: 0, left: '20px', padding: '8px', color: '#000' }}>
                        {currentTime}
                    </div>
                    <Alert message={t(title)} banner type="info" showIcon />
                    <Button style={{ marginTop: '8px' }}
                        onClick={() => {
                            downloadExcel(notification.data, fileName);
                        }}
                    >
                        {t('Download File')}
                    </Button>
                </>
            )}
            {notification && notification.data.MessageError &&
                <Alert style={{ whiteSpace: 'normal', textOverflow: 'ellipsis', overflow: 'auto' }} message={notification.data.MessageError} banner type="error" showIcon />}
        </>
    );
};

export default withTranslation()(ExportNotification);
